import { useContext, useEffect, useState } from 'preact/hooks';
import { SessionContext } from '../app.jsx';
import { get, post } from '../api.js';
import { Field, useForm } from '../ui/Field.jsx';
import { fmtRange } from '../../lib/dates.js';

const ROLE = { guide: 'Vodič', office: 'Kancelarija' };
const EMPTY = { name: '', username: '', role: 'guide' };

function Stanje({ busy }) {
  if (!busy) return <span class="tag tag-slobodno">Slobodno</span>;
  return (
    <span>
      <span class="tag tag-zauzeto">Zauzeto</span> {busy.tour}, {fmtRange(busy.start_date, busy.end_date)}
    </span>
  );
}

export function Users() {
  const { user: me } = useContext(SessionContext);
  const [users, setUsers] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [adding, setAdding] = useState(false);
  const [f, bind, setF] = useForm(EMPTY);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [temp, setTemp] = useState(null); // { name, password }

  const load = () => get('/users').then((r) => { setUsers(r.users); setLoadError(null); }, (e) => setLoadError(e.message));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const r = await post('/users', f);
      setTemp({ name: r.user.name, password: r.password });
      setAdding(false);
      setF(EMPTY);
      await load();
    } catch (err) {
      setError(err.message);
    }
    setBusy(false);
  };

  const reset = async (u) => {
    if (!confirm(`Napraviti novu privremenu lozinku za ${u.name}? Biće odjavljen sa svih uređaja.`)) return;
    setError(null);
    try {
      const r = await post(`/users/${u.id}/reset`);
      setTemp({ name: u.name, password: r.password });
      await load();
    } catch (err) {
      setError(err.message);
    }
  };

  const guides = users?.filter((u) => u.role === 'guide') ?? [];

  return (
    <>
      <div class="page-head">
        <h1>Vodiči i kancelarija</h1>
        {!adding && <button class="btn" onClick={() => { setAdding(true); setTemp(null); setError(null); }}>Novi korisnik</button>}
      </div>

      {temp && (
        <section class="panel temp" aria-live="polite">
          <p>Privremena lozinka za {temp.name}:</p>
          <code data-testid="temp-password" data-g3-mask>{temp.password}</code>
          <p>Prenesi je lično. Pri prvoj prijavi traži se nova.</p>
          <button class="btn-quiet" onClick={() => setTemp(null)}>Gotovo</button>
        </section>
      )}

      {adding && (
        <form class="panel inline-form" onSubmit={create}>
          <Field label="Ime i prezime"><input {...bind('name')} autocomplete="off" required /></Field>
          <Field label="Korisničko ime">
            <input {...bind('username')} autocomplete="off" autocapitalize="none" spellcheck={false} required />
          </Field>
          <Field label="Uloga">
            <select {...bind('role')}>
              <option value="guide">Vodič</option>
              <option value="office">Kancelarija</option>
            </select>
          </Field>
          <div class="actions">
            <button class="btn" disabled={busy}>Napravi korisnika</button>
            <button type="button" class="btn-quiet" onClick={() => { setAdding(false); setError(null); }}>Odustani</button>
          </div>
        </form>
      )}

      {error && <p class="alert" role="alert">{error}</p>}
      {loadError && <p class="alert" role="alert">{loadError}</p>}

      {users && guides.length === 0 && <p class="empty">Još nema vodiča. Napravi prvog: Novi korisnik.</p>}

      {users && (
        <table class="stack">
          <thead>
            <tr><th>Ime</th><th>Korisničko ime</th><th>Uloga</th><th>Stanje</th><th><span class="sr-only">Lozinka</span></th></tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td data-label="Ime">{u.name}</td>
                <td data-label="Korisničko ime">{u.username}</td>
                <td data-label="Uloga">{ROLE[u.role]}</td>
                <td data-label="Stanje">{u.role === 'guide' && <Stanje busy={u.busy} />}</td>
                <td class="cell-action">
                  {u.id !== me.id && <button class="btn-quiet" onClick={() => reset(u)}>Nova privremena lozinka</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
